import graphql__c54435adc10b2d97122b from "./__generated__/ShallowAnswerPreview_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import AnswerPreviewString from "./AnswerPreviewString";
import AnswerPreviewText from "./AnswerPreviewText";
import AnswerPreviewRichText from "./AnswerPreviewRichText";
import AnswerPreviewFile from "./AnswerPreviewFile";
import AnswerPreviewCheckBoxes from "./AnswerPreviewCheckBoxes";
import AnswerPreviewBudgetDispatcher from "./AnswerPreviewBudgetDispatcher";
import AnswerPreviewSortableList from "./AnswerPreviewSortableList";
import AnswerPreviewMatrix from "./AnswerPreviewMatrix";
import AnswerPreviewThemes from "./AnswerPreviewThemes";
import AnswerPreviewEvents from "./AnswerPreviewEvents";
import AnswerPreviewEmailWithConsents from "./AnswerPreviewEmailWithConsents";
import AnswerPreviewOralInterview from "./AnswerPreviewOralInterview";
import AnswerPreviewPresentationSeparator from "./AnswerPreviewPresentationSeparator";
import AnswerPreviewPresentationTitle from "./AnswerPreviewPresentationTitle";
import AnswerPreviewPresentationTextZone from "./AnswerPreviewPresentationTextZone";

const types = {
  AnswerPreviewString,
  AnswerPreviewText,
  AnswerPreviewRichText,
  AnswerPreviewFile,
  AnswerPreviewCheckBoxes,
  AnswerPreviewBudgetDispatcher,
  AnswerPreviewSortableList,
  AnswerPreviewMatrix,
  AnswerPreviewThemes,
  AnswerPreviewEvents,
  AnswerPreviewEmailWithConsents,
  AnswerPreviewOralInterview,
  AnswerPreviewPresentationSeparator,
  AnswerPreviewPresentationTitle,
  AnswerPreviewPresentationTextZone
};

const ShallowAnswerPreview = props => {
  const typename = "AnswerPreview" + props.answer.__typename.replace(/^Answer/, "");
  const AnswerPreviewType = types[typename];

  return <AnswerPreviewType answer={props.answer} />;
};

const ShallowAnswerPreviewContainer = createFragmentContainer(ShallowAnswerPreview, {
  answer: graphql__c54435adc10b2d97122b
});

ShallowAnswerPreviewContainer.types = types;

export default ShallowAnswerPreviewContainer;
